import { FC } from 'react';

import { Button, Modal } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { Z_INDEX_MODAL } from '../../../../constants/constants';
import { SPECIAL_OFFERS_TEST_ID } from '../test-ids';
import { useSpecialOfferSingleModalControls } from '../useSpecialOfferModalControls';
import { HorizontalAlignment, Pictogram } from './compoents/SpecialOfferModal.styles';

export const SpecialOfferSingleModal: FC = () => {
    const { t } = useTranslations();
    const { modalData, closeModal, isModalOpen } = useSpecialOfferSingleModalControls();

    const isHorizontalAlignment = modalData?.imagePosition === 'LEFT';
    const buttons = [
        <Button key="close" variant="primary" onClick={closeModal} data-test={ESHOP_TEST_ID.MODAL_CLOSE_BTN}>
            {t['common.button.close']}
        </Button>,
    ];
    const description = <HtmlContent content={modalData?.description} />;

    return (
        <Modal open={isModalOpen} onOpenChange={(open) => !open && closeModal()}>
            <Modal.Content
                title={modalData?.title}
                actions={<>{buttons}</>}
                stickyButtons={true}
                image={
                    !isHorizontalAlignment &&
                    !!modalData?.image?.url && <img src={modalData?.image?.url} alt={modalData?.image?.altText} />
                }
                closeButtonAriaLabel={t['common.button.close']}
                showCloseButton={true}
                data-test={SPECIAL_OFFERS_TEST_ID.SINGLE_MODAL}
                zIndex={Z_INDEX_MODAL}
            >
                {isHorizontalAlignment ? (
                    <HorizontalAlignment>
                        <Pictogram src={modalData?.image?.url} alt={modalData?.image?.altText} />
                        {description}
                    </HorizontalAlignment>
                ) : (
                    description
                )}
            </Modal.Content>
        </Modal>
    );
};
